import React, { memo } from "react";
import { useInView } from "react-intersection-observer";
import { GalleryImage } from "./GalleryModal.styles";

const GalleryItem = ({ url, isAdded, onToggle, initialAspectRatio }) => {
  const { ref, inView } = useInView({
    threshold: 0.01,
    rootMargin: "400px",
    triggerOnce: true,
  });

  const transparentPlaceholder =
    "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAiIGhlaWdodD0iMTYwIiB2aWV3Qm94PSIwIDAgMTIwIDE2MCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJnIiB4MT0iMCIgeTE9IjAiIHgyPSIxMjAiIHkyPSIwIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjMWExYTFlIi8+PHN0b3Agb2Zmc2V0PSIwLjUiIHN0b3AtY29sb3I9IiMyNjI2MmMiLz48c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiMxYTFhMWUiLz48L2xpbmVhckdyYWRpZW50PjwvZGVmcz48cmVjdCB3aWR0aD0iMTIwIiBoZWlnaHQ9IjE2MCIgZmlsbD0idXJsKCNnKSIvPjwvc3ZnPg==";
  return (
    <GalleryImage
      ref={ref}
      $isAdded={isAdded}
      onClick={onToggle}
      src={inView ? url : transparentPlaceholder}
      alt={url}
      style={{ aspectRatio: initialAspectRatio }}
    />
  );
};

export default memo(GalleryItem);
